interface CardWheelInput {
  deltaX: number;
  deltaY: number;
  shiftKey: boolean;
}

export function cardTagScrollDelta({
  deltaX,
  deltaY,
  shiftKey
}: CardWheelInput): number | null {
  const horizontalGesture = Math.abs(deltaX) > Math.abs(deltaY);
  if (!shiftKey && !horizontalGesture) return null;

  if (!shiftKey) return deltaX;
  return Math.abs(deltaY) >= Math.abs(deltaX) ? deltaY : deltaX;
}
